var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUptime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 151.25,
    viewBox: "0 0 150 151.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(-2851 -985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 150,
    height: 151.25,
    transform: "translate(2851 985)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "blockchain_2_",
    "data-name": "blockchain (2)",
    transform: "translate(2864.439 997.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(104.176 43.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M424.549,186.457a1.871,1.871,0,0,1-1.871-1.871v-3.824a1.871,1.871,0,0,1,3.741,0v3.824A1.871,1.871,0,0,1,424.549,186.457Z",
    transform: "translate(-422.678 -178.892)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(104.176 53.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M424.549,227.514a1.871,1.871,0,0,1-1.871-1.871V221.82a1.871,1.871,0,0,1,3.741,0v3.823A1.871,1.871,0,0,1,424.549,227.514Z",
    transform: "translate(-422.678 -219.949)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(104.176 63.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M424.549,268.571a1.871,1.871,0,0,1-1.871-1.871v-3.824a1.871,1.871,0,0,1,3.741,0V266.7A1.871,1.871,0,0,1,424.549,268.571Z",
    transform: "translate(-422.678 -261.006)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(104.176 73.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M424.549,309.628a1.871,1.871,0,0,1-1.871-1.871v-3.823a1.871,1.871,0,0,1,3.741,0v3.823A1.871,1.871,0,0,1,424.549,309.628Z",
    transform: "translate(-422.678 -302.063)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(19.205 43.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M75.839,186.457a1.871,1.871,0,0,1-1.871-1.871v-3.824a1.871,1.871,0,0,1,3.741,0v3.824A1.871,1.871,0,0,1,75.839,186.457Z",
    transform: "translate(-73.968 -178.892)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(19.205 53.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M75.839,227.514a1.871,1.871,0,0,1-1.871-1.871V221.82a1.871,1.871,0,1,1,3.741,0v3.823A1.871,1.871,0,0,1,75.839,227.514Z",
    transform: "translate(-73.968 -219.949)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(19.205 63.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M75.839,268.571a1.871,1.871,0,0,1-1.871-1.871v-3.824a1.871,1.871,0,0,1,3.741,0V266.7A1.871,1.871,0,0,1,75.839,268.571Z",
    transform: "translate(-73.968 -261.006)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(19.205 73.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M75.839,309.628a1.871,1.871,0,0,1-1.871-1.871v-3.823a1.871,1.871,0,1,1,3.741,0v3.823A1.871,1.871,0,0,1,75.839,309.628Z",
    transform: "translate(-73.968 -302.063)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(70.177 18.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M289.03,77.709h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-283.15 -73.968)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(59.686 18.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M245.976,77.709h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-240.096 -73.968)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(80.668 18.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M332.085,77.709h-4.01a1.871,1.871,0,1,1,0-3.741h4.01a1.871,1.871,0,1,1,0,3.741Z",
    transform: "translate(-326.205 -73.968)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(49.194 18.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M202.921,77.709h-4.01a1.871,1.871,0,1,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-197.041 -73.968)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(38.703 18.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M159.866,77.709h-4.01a1.871,1.871,0,1,1,0-3.741h4.01a1.871,1.871,0,1,1,0,3.741Z",
    transform: "translate(-153.986 -73.968)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(70.177 102.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M289.03,426.419h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-283.15 -422.678)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(59.686 102.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M245.976,426.419h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-240.096 -422.678)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(80.668 102.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M332.085,426.419h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,1,1,0,3.741Z",
    transform: "translate(-326.205 -422.678)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(49.194 102.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M202.921,426.419h-4.01a1.871,1.871,0,0,1,0-3.741h4.01a1.871,1.871,0,0,1,0,3.741Z",
    transform: "translate(-197.041 -422.678)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(38.703 102.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M159.866,426.419h-4.01a1.871,1.871,0,1,1,0-3.741h4.01a1.871,1.871,0,1,1,0,3.741Z",
    transform: "translate(-153.986 -422.678)",
    fill: "#ffd496"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 27.372,
    cy: 27.372,
    rx: 27.372,
    ry: 27.372,
    transform: "translate(36.189 35.008)",
    fill: "#fee7c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M266.309,171.042a27.4,27.4,0,0,1-32.869,26.82,26.824,26.824,0,0,0,.012-53.64,27.386,27.386,0,0,1,32.857,26.82Z",
    transform: "translate(-175.376 -108.661)",
    fill: "#ffd496"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(36.275 35.055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 20.898,
    cy: 20.898,
    rx: 20.898,
    ry: 20.898,
    transform: "translate(0 16.008) rotate(-22.514)",
    fill: "#fb9927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(56.705 41.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M255.618,191.137a20.895,20.895,0,0,1-27.752,19.74c.516.041,1.039.063,1.567.063a19.8,19.8,0,0,0,0-39.607q-.792,0-1.567.063a20.895,20.895,0,0,1,27.752,19.74Z",
    transform: "translate(-227.866 -170.239)",
    fill: "#f98824"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M240.168,214.55a7.625,7.625,0,0,0-2.5-5.648,1.034,1.034,0,0,1-.167-1.328,6.627,6.627,0,0,0-3.243-9.768,1.018,1.018,0,0,1-.649-.954v-1.6a1.028,1.028,0,0,0-1.027-1.028H230.9a1.027,1.027,0,0,0-1.027,1.028v1.092a1.028,1.028,0,0,1-2.055,0v-1.092a1.028,1.028,0,0,0-1.027-1.028H225.1a1.027,1.027,0,0,0-1.027,1.028v1.092a1.027,1.027,0,0,1-1.028,1.027h-1.851a1.027,1.027,0,0,0-1.027,1.028v1.687a1.028,1.028,0,0,0,1.027,1.028h1.089a1.028,1.028,0,0,1,1.028,1.027v15.283a1.028,1.028,0,0,1-1.028,1.028h-1.089a1.027,1.027,0,0,0-1.027,1.027v1.687a1.027,1.027,0,0,0,1.027,1.027h1.851a1.028,1.028,0,0,1,1.028,1.027v1.092a1.027,1.027,0,0,0,1.027,1.027h1.687a1.027,1.027,0,0,0,1.027-1.027v-1.092a1.028,1.028,0,0,1,2.055,0v1.092a1.027,1.027,0,0,0,1.027,1.027h1.687a1.027,1.027,0,0,0,1.027-1.027V222.96a1.02,1.02,0,0,1,.767-.992A7.659,7.659,0,0,0,240.168,214.55Zm-8.258-13.432a2.9,2.9,0,0,1,2.88,3.171,2.949,2.949,0,0,1-2.964,2.614h-3.746a1.027,1.027,0,0,1-1.027-1.027v-3.73a1.027,1.027,0,0,1,1.027-1.027h3.831Zm.5,17.338h-4.329a1.027,1.027,0,0,1-1.027-1.028v-5.756a1.027,1.027,0,0,1,1.027-1.027h4.442a3.91,3.91,0,0,1,3.9,4.1A3.98,3.98,0,0,1,232.408,218.456Z",
    transform: "translate(-165.337 -146.9)",
    fill: "#ffd496"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(1.593 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M21.19,59.873l19.5-11.294V70.338a1.247,1.247,0,0,1-.622,1.079L21.815,81.989a1.247,1.247,0,0,1-1.25,0L2.314,71.416a1.247,1.247,0,0,1-.622-1.079V48.579Z",
    transform: "translate(-1.692 -48.579)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(1.593 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M22.437,59.15V81.629l-.621.359a1.249,1.249,0,0,1-1.252,0L2.313,71.417a1.253,1.253,0,0,1-.621-1.08V48.579l19.5,11.294Z",
    transform: "translate(-1.692 -48.579)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(14.967 19.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M62.7,83.921v22.284a1.248,1.248,0,0,1-.626-.17l-5.5-3.185V80.374Z",
    transform: "translate(-56.579 -80.374)",
    fill: "#213993"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(21.091 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M101.208,48.579V70.337a1.252,1.252,0,0,1-.621,1.08L82.336,81.988a1.248,1.248,0,0,1-.626.17V59.874Z",
    transform: "translate(-81.71 -48.579)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(33.538 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M139.84,48.579V70.337a1.252,1.252,0,0,1-.621,1.08l-6.43,3.724V52.665Z",
    transform: "translate(-132.789 -48.579)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(1.561 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M2.183,10.759,20.466.169a1.247,1.247,0,0,1,1.25,0L40,10.759a1.247,1.247,0,0,1,0,2.158L21.716,23.507a1.247,1.247,0,0,1-1.25,0L2.183,12.917a1.247,1.247,0,0,1,0-2.158Z",
    transform: "translate(-1.561 -0.001)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M77.076,12.92,70.6,16.669,50.581,4.2,57.54.172a1.249,1.249,0,0,1,1.252,0L77.076,10.76A1.25,1.25,0,0,1,77.076,12.92Z",
    transform: "translate(-37.075 -0.002)",
    fill: "#5169cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(1.593 91.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M21.189,385.491l19.5-11.294v21.759a1.247,1.247,0,0,1-.622,1.079L21.815,407.607a1.247,1.247,0,0,1-1.25,0L2.313,397.035a1.247,1.247,0,0,1-.622-1.079V374.2Z",
    transform: "translate(-1.691 -374.197)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(1.593 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M22.437,384.769v22.479l-.621.359a1.249,1.249,0,0,1-1.252,0L2.313,397.036a1.252,1.252,0,0,1-.621-1.08V374.2l19.5,11.294Z",
    transform: "translate(-1.692 -374.198)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(14.967 98.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M62.7,409.539v22.284a1.247,1.247,0,0,1-.626-.17l-5.5-3.185V405.992Z",
    transform: "translate(-56.579 -405.992)",
    fill: "#213993"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(21.091 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M101.207,374.2v21.758a1.252,1.252,0,0,1-.621,1.08L82.335,407.607a1.249,1.249,0,0,1-.626.17V385.492Z",
    transform: "translate(-81.709 -374.198)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(33.538 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M139.84,374.2v21.758a1.252,1.252,0,0,1-.621,1.08l-6.43,3.724V378.284Z",
    transform: "translate(-132.789 -374.198)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(1.561 79.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M2.183,336.377l18.283-10.59a1.247,1.247,0,0,1,1.25,0L40,336.377a1.247,1.247,0,0,1,0,2.158l-18.283,10.59a1.247,1.247,0,0,1-1.25,0L2.183,338.535a1.247,1.247,0,0,1,0-2.158Z",
    transform: "translate(-1.561 -325.619)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M77.076,338.538,70.6,342.287,50.581,329.82l6.959-4.031a1.249,1.249,0,0,1,1.252,0l18.284,10.588A1.25,1.25,0,0,1,77.076,338.538Z",
    transform: "translate(-37.075 -246.275)",
    fill: "#5169cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(86.532 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M369.769,59.873l19.5-11.294V70.338a1.247,1.247,0,0,1-.622,1.079L370.393,81.989a1.247,1.247,0,0,1-1.25,0L350.892,71.417a1.247,1.247,0,0,1-.622-1.079V48.579Z",
    transform: "translate(-350.27 -48.579)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(86.532 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M371.016,59.15V81.629l-.621.359a1.249,1.249,0,0,1-1.252,0L350.892,71.417a1.253,1.253,0,0,1-.621-1.08V48.579l19.5,11.294Z",
    transform: "translate(-350.271 -48.579)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(99.907 19.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M411.281,83.921v22.284a1.248,1.248,0,0,1-.626-.17l-5.5-3.185V80.374Z",
    transform: "translate(-405.158 -80.374)",
    fill: "#213993"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(106.031 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M449.787,48.579V70.337a1.252,1.252,0,0,1-.621,1.08L430.915,81.988a1.249,1.249,0,0,1-.626.17V59.874Z",
    transform: "translate(-430.289 -48.579)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(118.477 11.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M488.419,48.579V70.337a1.252,1.252,0,0,1-.621,1.08l-6.43,3.724V52.665Z",
    transform: "translate(-481.368 -48.579)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(86.5 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M350.762,10.759,369.045.169a1.248,1.248,0,0,1,1.25,0l18.283,10.59a1.247,1.247,0,0,1,0,2.158L370.3,23.507a1.248,1.248,0,0,1-1.25,0l-18.283-10.59A1.247,1.247,0,0,1,350.762,10.759Z",
    transform: "translate(-350.14 -0.001)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M425.655,12.92l-6.473,3.749L399.16,4.2,406.119.172a1.249,1.249,0,0,1,1.252,0L425.655,10.76A1.25,1.25,0,0,1,425.655,12.92Z",
    transform: "translate(-300.715 -0.002)",
    fill: "#5169cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(86.532 91.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M369.769,385.491l19.5-11.294v21.759a1.247,1.247,0,0,1-.622,1.079l-18.251,10.572a1.247,1.247,0,0,1-1.25,0l-18.251-10.572a1.247,1.247,0,0,1-.622-1.079V374.2Z",
    transform: "translate(-350.27 -374.197)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(86.532 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M371.016,384.769v22.479l-.621.359a1.249,1.249,0,0,1-1.252,0l-18.251-10.571a1.253,1.253,0,0,1-.621-1.08V374.2l19.5,11.294Z",
    transform: "translate(-350.271 -374.198)",
    fill: "#2944ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(99.907 98.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M411.281,409.539v22.284a1.248,1.248,0,0,1-.626-.17l-5.5-3.185V405.992Z",
    transform: "translate(-405.158 -405.992)",
    fill: "#213993"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(106.031 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M449.787,374.2v21.758a1.252,1.252,0,0,1-.621,1.08l-18.251,10.571a1.248,1.248,0,0,1-.626.17V385.492Z",
    transform: "translate(-430.289 -374.198)",
    fill: "#627be6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(118.477 91.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M488.419,374.2v21.758a1.252,1.252,0,0,1-.621,1.08l-6.43,3.724V378.284Z",
    transform: "translate(-481.368 -374.198)",
    fill: "#3351c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(86.5 79.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M350.762,336.377l18.283-10.59a1.247,1.247,0,0,1,1.25,0l18.283,10.59a1.247,1.247,0,0,1,0,2.158L370.3,349.125a1.247,1.247,0,0,1-1.25,0l-18.283-10.59A1.247,1.247,0,0,1,350.762,336.377Z",
    transform: "translate(-350.14 -325.619)",
    fill: "#7c91ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M425.655,338.538l-6.473,3.749L399.16,329.82l6.959-4.031a1.248,1.248,0,0,1,1.252,0l18.284,10.588A1.25,1.25,0,0,1,425.655,338.538Z",
    transform: "translate(-300.715 -246.275)",
    fill: "#5169cd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptime);
export default __webpack_public_path__ + "static/media/uptime.54e8045fd19fcca8b179c44232ff36ed.svg";
export { ForwardRef as ReactComponent };